import {
  component_styles_default
} from "./chunk.BKUJPVXD.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/carousel/carousel-slide.styles.ts
var carousel_slide_styles_default = r` ${component_styles_default} :host { position: absolute; top: 0; left: 0; height: 100%; width: 100%; outline: none; opacity: 0; display: block; z-index: 1; background-size: cover; } :host([active]) { opacity: 1; z-index: 100; } .carousel-slide { width: 100%; position: relative; } `;

export {
  carousel_slide_styles_default
};
